import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'

// Webflow's easing presets, recreated as exact cubic-bezier curves so the
// motion matches the original site one-to-one.
const WF_EASES: Record<string, string> = {
    ease: 'M0,0 C0.25,0.1 0.25,1 1,1',
    inOutCubic: 'M0,0 C0.645,0.045 0.355,1 1,1',
    inOutQuart: 'M0,0 C0.77,0 0.175,1 1,1',
    inBack: 'M0,0 C0.6,-0.28 0.735,0.045 1,1',
    inOutBack: 'M0,0 C0.68,-0.55 0.265,1.55 1,1'
}

let registered = false

export function registerGsap() {
    if (registered || typeof window === 'undefined') return

    gsap.registerPlugin(ScrollTrigger, CustomEase)

    for (const [name, path] of Object.entries(WF_EASES)) {
        CustomEase.create(`wf-${name}`, path)
    }

    registered = true
}

// Maps a Webflow easing keyword to the registered GSAP ease name.
export function wfEase(name?: string) {
    if (!name) return 'wf-ease'
    return WF_EASES[name] ? `wf-${name}` : 'wf-ease'
}

export function prefersReducedMotion() {
    if (typeof window === 'undefined') return false
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export { gsap, ScrollTrigger }
